<template lang="pug">
  app-page.gsu-module(title="Главное следственное управление" :fab-items="items")
    listToolbar
    
    CaseDocuments(:docList="preparedDocuments" v-if="ordinances.length > 0" :memberTitle="'Обвиняемый'")

    signDoc(v-model="dialogSign" :doc.sync="doc" @sended="sended" @sendfail="showErrorSnack($event)")
    v-snackbar(v-model="errorSnack" color="error" :timeout="6000" vertical top) {{errorSnackText}}
      v-btn(light text @click="errorSnack = false") Закрыть

</template>

<script>
import moment from 'moment'
import { mapGetters, mapState, mapMutations } from 'vuex';
import listToolbar from './components/ListToolbar'
import CaseDocuments from "@/pages/cases/components/CaseDocuments"
import signDoc from '@/pages/signature/components/SignDoc'

const colors = ['red', 'yellow', 'green']

export default {
  components: {
    listToolbar,
    CaseDocuments,
    signDoc
  },
  data() {
    return {
      errorSnackText: "Ошибка при подписании",
      errorSnack: false,
      dialogSign: false,
      doc: null
    }
  },

  computed: {
    ...mapGetters('gsu', ['ordinances']),
    ...mapState('gsu', ['selectedStatus', 'period', 'selectedSort', 'lastSendable']),

    items () {

      let items = [
        { icon:'add', title:'Исходящее постановление', action: () => this.showDataRequestDialog() }, 
      ]
      return items
    },

    preparedDocuments () {
      let list = (this.selectedStatus == null) ? this.ordinances : this.ordinances.filter(c => c.deliveryStatus.value == this.selectedStatus.value)

      if (this.period) {
        list = list.filter(item => moment(item.createDate).isBetween(this.period.start, this.period.end, 'day', '[]'))
      }

      if (list) {
        switch (this.selectedSort) {
          case 1:
            list.sort((a, b) => a.deliveryStatus.value-b.deliveryStatus.value)
            break;
          default:
            list.sort((a, b) => b.createDate.localeCompare(a.createDate))
            break;
        }
      }

      return list.map(d => {
        d.date = this.date(d)
        d.time = this.time(d)
        d.color = this.statusColor(d)

        let recipient = this.recipient(d)
        d.recipientName = this.recipientName(recipient)

        if(recipient.persona.personaData) {
            let addressItems = recipient.persona.personaData.filter(item => item.dataType.name === 'ADDRESS').sort((a, b) => b.id - a.id)
            let item = addressItems.find(item => item.tag && item.tag.name == 'MAIN') || addressItems[0]
            d.address = item ? item.data : ''
        }

        return d
      })
    },
  },
  methods: {
    ...mapMutations('gsu', [ 'setLastSendable']),

    showErrorSnack(text) {
      this.errorSnackText = text
      this.errorSnack = true
    },
    date (d) {
      return moment(d.createDate).format("DD.MM.YYYY")
    },

    time (d) {
      return moment(d.createDate).format("HH:mm")
    },

    statusColor (d) {
      return colors[d.deliveryStatus.color]
    },

    recipient (d) {
      let member = d.sendable.member
      return member ? member : {persona:{address: "Адрес организации", name:"Запрос на организацию", personaType: "UL"}}
    },

    recipientName (member) {
      let { persona } = member
      return (persona.personaType.name == 'UL' && persona.orgName.length > 0) ? persona.orgName : persona.name
    },

    showDataRequestDialog () {
      this.$router.push({name: 'gsuOrdinancesAdd'})
    },
    sended () {
      this.$store.dispatch('gsu/LOAD_Ordinances')
    },
  },
  created() {
    this.$store.dispatch('gsu/INIT', { defaultStatus: 'SIGNREQUIRED' })
  },
  mounted() {
    this.$nextTick(() => {
      if(this.lastSendable!=null) {
         this.doc = this.ordinances.filter(item => item.sendable.id == this.lastSendable)[0]
         this.setLastSendable(null)
         if (this.doc !== undefined)
           this.dialogSign = true
      }
    })
  }
}


</script>

<style lang="scss" scoped>
.ellipse {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-left: 6px;

  &[data-color="red"] {
    background: #ED0E51;
  }
  &[data-color="yellow"] {
    background: #F2BE38;
  }
  &[data-color="green"] {
    background: #2BC113;
  }
}
</style>

<style lang="scss">
.gsu-module {
 .document {
   display: flex;
   flex-flow: row wrap;
   margin-left: -14px;
   margin-right: -14px;
   >div {
     width: 33.3333333333%;
     background-color: transparent;
     padding-left: 14px;
     padding-right: 14px;
     margin-bottom: 14px;
   }
 }
}
</style>
